export class OrderInfoOverview {
  submittedOrderInfoOverviewList!: OrderInfoOverviewData[];
  deliveredOrderInfoOverviewList!: OrderInfoOverviewData[];
  openOrderInfoOverviewList!: OrderInfoOverviewData[];
}

export class OrderInfoOverviewData {
  orderInfoHeaderID: any;
  orderDate: any;
  deliveryDate!: Date;
  harborName!: string;
  countryName!: string;
  departmentName!: string;
  productCount!: number;
  currencySymbol!: string;
  total!: number;
  contractCurrencySymbol!: string;
  contractTotalPrice!: number;
  orderStatusID: any;
  wsStatus!: string;
  wsStatusDesc!: string;
  isDelivered!: boolean;
  withSurveyEmail!: boolean;
  answersReceived!: boolean;
  agentFullName!: string;
  agentTelephone!: string;
  agentEmail!: string;
  supplierName!: string;
  supplierEmail!: string;
  supplierMobile!: string;
  createUserID!: number;
  isUpdatedOffline!: boolean;
  isTempApproved!: boolean;
  isTempDeleted!: boolean;
  discount!: number;
  isIMI!: boolean;
  isSubmittedFromIMI!: boolean;
  overviewGroup!: string;
  inventoryDisposalTypeID!: number;
  inventoryDisposalDescription!: string;
  referenceShipName!: string;
  skipCatalog?: boolean;

  productCountReturnedItems!: number;
  showChangedItemsOnly?:boolean = true;
}
